function PreviewSection({
  title,
  children,
  isEmpty = false,
  noRibbon = false,
}) {
  return (
    <div className={`preview-section ${isEmpty ? "is-empty" : ""}`}>
      <h4>{title}</h4>
      <div className={`preview-content ${noRibbon ? "no-ribbon" : ""}`}>
        {isEmpty ? <p className="empty-text">Not yet available</p> : children}
      </div>
    </div>
  );
}

export default PreviewSection;
